import React, { useId } from 'react';
import PropTypes from 'prop-types';

const trainerLabelForSportType = (sportType, labels, initialLabel) => {
  const RUN_SPORTS = ['Run', 'VirtualRun', 'Walk'];
  const RIDE_SPORTS = [
    'Ride',
    'VirtualRide',
    'EBikeRide',
    'Handcycle',
    'Velomobile'
  ];

  switch (true) {
    case RUN_SPORTS.includes(sportType):
      return labels.Run;
    case RIDE_SPORTS.includes(sportType):
      return labels.Ride;
    case sportType === 'Swim':
      return labels.Swim;
    default:
      return initialLabel || labels.Ride;
  }
};

const ActivityTagInput = ({ legend, tagOptions, trainerOption, sportType }) => {
  const uid = useId();

  return (
    <fieldset>
      <legend>{legend}</legend>
      <input type="hidden" name="activity[tags][]" value="" />
      <div className="inline-inputs marginless">
        {tagOptions.map((tag) => {
          const inputId = `${uid}-${tag.key}`;
          return (
            <div
              key={tag.key}
              className="input-field"
              data-tag-sports={tag.sportTypes.join(',')}
              style={
                sportType && !tag.sportTypes.includes(sportType)
                  ? { display: 'none' }
                  : undefined
              }
            >
              <input
                type="checkbox"
                name="activity[tags][]"
                value={tag.gqlString}
                defaultChecked={tag.selected}
                id={inputId}
              />
              <label htmlFor={inputId}>
                <span className="tag-label">{tag.label}</span>
                <div className="hole" />
              </label>
            </div>
          );
        })}
        {trainerOption && (
          <>
            <input type="hidden" name="activity[trainer]" value="0" />
            <div
              className="input-field trainer_tag"
              data-tag-sports={trainerOption.sportTypes.join(',')}
              style={
                sportType && !trainerOption.sportTypes.includes(sportType)
                  ? { display: 'none' }
                  : undefined
              }
              data-label-run={trainerOption.labels.Run}
              data-label-ride={trainerOption.labels.Ride}
              data-label-swim={trainerOption.labels.Swim}
            >
              <input
                type="checkbox"
                name="activity[trainer]"
                value="1"
                defaultChecked={trainerOption.selected}
                id={`${uid}-trainer`}
              />
              <label htmlFor={`${uid}-trainer`}>
                <span className="tag-label trainer-label">
                  {trainerLabelForSportType(
                    sportType,
                    trainerOption.labels,
                    trainerOption.initialLabel
                  )}
                </span>
                <div className="hole" />
              </label>
            </div>
          </>
        )}
      </div>
    </fieldset>
  );
};

ActivityTagInput.propTypes = {
  legend: PropTypes.string,
  sportType: PropTypes.string,
  tagOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      key: PropTypes.string.isRequired,
      gqlString: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      selected: PropTypes.bool.isRequired,
      sportTypes: PropTypes.arrayOf(PropTypes.string).isRequired
    })
  ),
  trainerOption: PropTypes.shape({
    selected: PropTypes.bool.isRequired,
    labels: PropTypes.shape({
      Ride: PropTypes.string.isRequired,
      Run: PropTypes.string.isRequired,
      Swim: PropTypes.string.isRequired
    }).isRequired,
    initialLabel: PropTypes.string,
    sportTypes: PropTypes.arrayOf(PropTypes.string).isRequired
  })
};

export default ActivityTagInput;
